import React, { Component } from "react";
import { Row, Col, Select } from "antd";
import profile from "../../../../assets/icons/profile-3.svg";
import { CancelButton, UpdateButton, DeleteModal, InlineLinkTo } from "./styles";
import {
  DisplayFlex,
  AlignItemsCenter,
  PrimaryIndicator,
  JustifyBetween,
  PrimaryButtonComponent,
  GhostButtonComponent,
  Spinner,
  BlurOverlay,BlurContainer} from "../../../../CommonComponents/commonStyles";
import { PersonnelHeading, ItemHeading, ItemData,MyAccountSelect } from "../../styles";
/*************************/

import {
  designatedDataSuccess,
  resetDesignatedDataSuccess,
  showComponent,
  fetchDropdownValues
} from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getPrimaryAccount, isGeminiUser,getAccountData } from "../../../../utils/sessionUtil";
import { recordError } from "../../../../utils/commonUtil";
import relationMapping from "../../../../CommonComponents/relationMapping";
import AlertCardComponent from "../../../../CommonComponents/Cards/AlertCard/AlertCard";

const Option = Select.Option;

class EditView extends Component {
  state = {
    renderAgain: 0,
    toBeDeleted: -1,
    modalVisible: false,
    modalName:null,
    localData: [],
    disable: 0,
    isSubmit:false,
    isIpaPrimaryContact:false
  };


  setModalVisible(index,name = null) {
    this.setState({
      modalVisible: !this.state.modalVisible,
      toBeDeleted: index,
      modalName:name
    });
  }

  componentDidMount() {
    let designatedParties = this.props.accData?.toJS().data.designatedParties.map((item)=>{
   item.isActive = true;
   return item;
    })
    const isIpaPrimaryContact = designatedParties.some((elm)=>{
      return elm.primaryAccountContact
    })

    this.setState({
      localData: designatedParties,
      isIpaPrimaryContact:isIpaPrimaryContact
    });
    this.props.fetchDropdownValues({
      metaData: [
        {
          method: "GET",
          page: "myAccount",
          url: `/donor-portal/api/dropDownValues/getCodeValueMapping`
        },
        {
          method: "GET",
          page: "myAccount",
          url: `/DP/Relationship/Types`,
          isBhoomiUrl:true
        }
      ]
    });
  }

  handleChange(value, index, field) {
    let dataArr = this.state.localData;
    if (field == "relation") {
      dataArr[index].relation = value.label;
      dataArr[index].salesforceRelationshipTypeId = value.key;
    } else if (field == "access") {
      dataArr[index].access = value;
    }
    this.setState({
      disable: 1,
      localData: [...dataArr]
    });
  }

  resetData = () => {
    this.setState({
      localData: this.props.resetData.toJS().data.designatedParties,
      disable: 0
    });
  };

  deleteAccess = index => {
    try {
      const arrAfter = this.state.localData;
      arrAfter[index].isActive = false;
      this.setState({
        disable: 1,
        modalVisible: !this.state.modalVisible,
        localData: [...arrAfter],
        modalName:null,
        toBeDeleted:-1
      });
    } catch (error) {
      recordError(error);
    }
  };
  disable = () => {
    if (
      this.state.localData == this.props.accData.toJS().data.designatedParties
    ) {
      return true;
    } else {
      return false;
    }
  };
  CountryCodeMappingData = data => {
    let countryName;
    if (this.props.countryCodeMappingData) {
      this.props.countryCodeMappingData.map(item => {
        if (item.value == data) {
          countryName = item.desc;
        }
      });
    }
    return countryName;
  };


  postData = () => {
    let obj = {};
    obj.accountId = getPrimaryAccount().userId;
    obj.designatedAccess =
      this.state.localData.map((item) => {
        return {
          "roleId": item.roleId,
          "role": item.role === "Interested Party" ? "Designated Party" : item.role,
          "access": item.access,
          "isActive":item.isActive
        }
      })
    obj.relationships = this.state.localData.reduce((acc, item) => {
      let relation = {}
      if (item.salesforceRelationshipTypeId != null && item.isActive) {
        relation.salesforceRelationshipId = item.salesforceRelationshipId;
        relation.loggedInUserPartyId  = getAccountData().partyId;
        relation.relatedPartyId = item.partyId;
        relation.salesforceRelationshipTypeId = item.salesforceRelationshipTypeId;
        relation.isActive = true
        acc.push(relation);
      }
      return acc;
    }, [])

    if(!this.state.isSubmit)
    {
      this.setState({
        isSubmit:true
      })

    const metaData = {
      method: "POST",
      url: `/DP/FinancialAccountRole/EditInterestedParties`,
      page: "myAccount",
      data: obj,
      isBhoomiUrl:true
      
    };
    let cb =new Promise((resolve)=>(metaData.submitDone = resolve));
    const updatedPayload = { reducerData: this.state.localData, metaData: metaData,currentReducer:this.props.accData?.toJS().data.designatedParties };
    this.props.designatedDataSuccess(updatedPayload);
    cb.then(()=>{
      this.props.toggleisEnabled();
      this.setState({
        isSubmit:false
      })
    })
 
  }
  };


  checkChange = () => {
    if (
      this.state.localData == this.props.resetData.toJS().data.designatedParties
    )
      return true;
  };
  render() {
    return (
      <>
      <AlertCardComponent show={this.state.isIpaPrimaryContact}>
      <p className="Notice">
      To remove or change access level of this Interested Party, you must first select another person to be the Primary Account Contact.
      </p>
      </AlertCardComponent>
        <Row type="flex">
          {this.state.localData && this.state.localData.length > 0 ? (
            this.state.localData.filter(item=>item.isActive).map((item, index) =>{              
              return  (
              <Col key={index} lg={8} md={8} xs={24} className={index > 2 ? "mt3" : ""} data-test="editView-Block">
                <Row>
                  <Col lg={2} md={2} xs={2}>
                    <img src={profile} alt="editInterestedParty" />
                  </Col>
                  <Col lg={22} md={22} xs={22}>
                    <AlignItemsCenter className="mb1">
                      <PersonnelHeading>
                        Interested Party {index + 1}
                      </PersonnelHeading>
                      {item.primaryAccountContact ? (
                        <PrimaryIndicator className="mb-10 ml2">
                          Primary
                        </PrimaryIndicator>
                      ) : (
                          ""
                        )}
                    </AlignItemsCenter>
                    <ItemData className="mt0">

                      {
                        (
                          !item.name &&
                          !item.salutation &&
                          !item.middleName &&
                          !item.lastName &&
                          !item.suffix) ? (
                            <> &mdash; </>
                          ) : (
                            ((item.salutation ? item.salutation + " " : '') + (item.name ? item.name + " " : '') + (item.middleName ? item.middleName + " " : "") + (item.lastName ? item.lastName  : "") + (item.suffix ? ", " + item.suffix : ""))
                          )}
                    </ItemData>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Email </ItemHeading>
                      <ItemData className="mt0 ml-05">{item.email}</ItemData>
                    </DisplayFlex>
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Phone </ItemHeading>
                      <ItemData className="mt0 ml-05">{item.phone}</ItemData>
                    </DisplayFlex>
                    {relationMapping[item.relation] == "Professional Advisor" ? (
                      <DisplayFlex className="mt-05">
                        <ItemHeading>Firm Name </ItemHeading>
                        <ItemData className="mt0 ml-05">
                          {item.firm == null || item.firm == "" ? (
                            <> &mdash; </>
                          ) : (
                              item.firm
                            )}
                        </ItemData>
                      </DisplayFlex>
                    ) : (
                        ""
                      )}
                    <DisplayFlex className="mt-05">
                      <ItemHeading>Address </ItemHeading>
                      <div>
                        <ItemData className="mt0 ml-05">
                          {item.address.address ? item.address.address  : ''}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.addressLine1 ? item.address.addressLine1  : ''}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.addressLine2 ? item.address.addressLine2  : ''}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.addressLine3 ? item.address.addressLine3  : ''}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {item.address.city?item.address.city+", ":""} {item.address.state}{" "}
                          {item.address.zipCode}
                        </ItemData>
                        <ItemData className="mt0 ml-05">
                          {this.CountryCodeMappingData(item.address.country)}
                        </ItemData>
                      </div>
                    </DisplayFlex>

                    <DisplayFlex className="mt-05">
                      <ItemHeading>Account Role</ItemHeading>
                      <ItemData className="mt0 ml-05">{item.role == "Trusted Advisor" ? "Professional Advisor " : item.role = "Designated Party" ? "Interested Party" : item.role}</ItemData>
                    </DisplayFlex>

                    <div className="mt-05">
                      <ItemHeading>Relation </ItemHeading>
                      <MyAccountSelect
                        data-test="myAcc-select"
                        labelInValue
                        value={{ key: item.relation}}
                        dropdownClassName="advisorSel"
                        width="300"
                        id={"selRelation" + index}
                        onSelect={e => this.handleChange(e, index, "relation")}
                      >
                        {Array.isArray(this.props.relationshipValuesData) && this.props.relationshipValuesData.map(item => {
                          return <Option value={item.value} key={item.desc}>{item.desc}</Option>
                        })}
                      </MyAccountSelect>
                    </div>
                    <BlurContainer>
                     <BlurOverlay isEnabled={!item.primaryAccountContact} />
                    <div className="mt2">
                      <ItemHeading>Access Level </ItemHeading>
                      <MyAccountSelect
                        data-test="access-level-block"
                        value={item.access ? item.access : ""}
                        dropdownClassName="advisorSel"
                        width="300"
                        id={"selAccessLevel" + index}
                        onSelect={e => this.handleChange(e, index, "access")}
                      >
                        <Option value="Full Access">Full Access</Option>
                        <Option value="Read Only + Exchange">Read Only + Exchange</Option>
                        <Option value="Read Only">Read Only Access</Option>
                        <Option value="No Access">Paper Access</Option>
                      </MyAccountSelect>
                    </div>
                    <div className="mt2">
                      <InlineLinkTo data-test="link-to-remove" id={"anrRemoveInterestedParty" + index} onClick={() => this.setModalVisible(index,item.name)}>
                        Remove Interested Party
                      </InlineLinkTo>
                    </div>
                    </BlurContainer>
                  </Col>
                </Row>
                {this.state.toBeDeleted == index ? (
                  <DeleteModal
                    data-test="remove-iip"
                    title="Remove Interested Party"
                    centered
                    onOk={() => this.setModalVisible()}
                    onCancel={() => this.setModalVisible()}
                    visible={this.state.modalVisible}
                    width="500px"
                    footer={[
                      <GhostButtonComponent
                        data-test="modal-cancel-btn"
                        key="back"
                        id="btnCancel1"
                        className="w25"
                        onClick={() => this.setModalVisible()}
                      >
                        Cancel
                      </GhostButtonComponent>,
                      <PrimaryButtonComponent
                        key="submit"
                        id="btnContinue"
                        className="w25"
                        onClick={() => this.deleteAccess(index)}
                      >
                        Continue
                      </PrimaryButtonComponent>
                    ]}
                  >
                    You are about to remove the Interested Party {this.state.toBeDeleted + 1}{" "}
                    i.e. {this.state.modalName}
                  </DeleteModal>
               ) : (
                    ""
                  )} 
              </Col>
            )})
          ) : (
              <ItemHeading data-test="no-data-block">No Data found</ItemHeading>
            )}
        </Row>
        <JustifyBetween className="mt3">
          <DisplayFlex>
            <CancelButton
              data-test="cancel-btn"
              id="btnCancel2"
              onClick={() => {
                this.props.showComponent();
                this.props.toggleisEnabled();
              }}
              width="150px"
            >
              Cancel
            </CancelButton>
          </DisplayFlex>
          <div>
            <UpdateButton
              data-test="update-btn"
              id="btnUpdate"
              disabled={isGeminiUser() ? true : ((this.state.disable|| this.state.isSubmit) ? false : true)}
              onClick={() => {
                this.postData();
              }}
              width="150px"
            >
             {this.state.isSubmit?<Spinner/>:"Update"} 
            </UpdateButton>
          </div>
        </JustifyBetween>
      </>
    );
  }
}

const mapStateToProps = state => ({
  accData: state.getIn(["myAccount", "accountData"]),
  resetData: state.getIn(["myAccount", "resetData"]),
  isLoadingAccount: state.getIn(["myAccount", "resetData", "isLoading"]),
  accountID: state.getIn(["globalState", "accountID"]),
  countryCodeMappingData: state.getIn(["myAccount", "countries"]),
  relationshipValuesData: state.getIn(["myAccount", "relationshipValues", "data"]),
});

export const mapDispatchToProps = dispatch => ({
  designatedDataSuccess: data => dispatch(designatedDataSuccess(data)),
  resetDesignatedDataSuccess: data =>
    dispatch(resetDesignatedDataSuccess(data)),
  showComponent: () => dispatch(showComponent()),
  fetchDropdownValues: data => dispatch(fetchDropdownValues(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditView)
);
